import { RouterView } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
export const routes: RouteRecordRaw[] = [
  {
    path: 'inventory',
    component: RouterView,
    meta: {
      layoutFeatures: {
        actionPanel: true,
      },
    },
    children: [
      {
        path: '',
        component: () => import('@/app/modules/inventory/views/inventory-index.vue'),
        redirect: '/inventory/location',
        children: [
          {
            path: 'location',
            component: () => import('@/app/modules/inventory/views/inventory-location.vue'),
          },
          {
            path: 'sku',
            component: () => import('@/app/modules/inventory/views/inventory-sku.vue'),
          },
          {
            path: 'inventories',
            component: () => import('@/app/modules/inventory/views/inventory-inventories.vue'),
          },
          {
            path: 'transactions',
            component: () => import('@/app/modules/inventory/views/inventory-transactions.vue'),
          },
          {
            path: 'product-locations',
            component: () =>
              import('@/app/modules/inventory/views/inventory-product-locations.vue'),
          },
        ],
      },
    ],
  },
];
export default routes;
